import type { ProLayoutProps } from '@ant-design/pro-components';
import { currentBrand } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 主题蓝色
  colorPrimary: '#2563eb',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: currentBrand.title,
  pwa: true,
  logo: currentBrand.logo,
  iconfontUrl: '',
  siderWidth: 256,
  token: {
    bgLayout: '#ffffff',
    sider: {
      colorMenuBackground: '#f7f8fa',
      colorTextMenu: '#5f6673',
      colorTextMenuSelected: '#2563eb',
      colorBgMenuItemSelected: '#ffffff',
      colorTextMenuItemHover: '#374151',
      colorBgMenuItemHover: 'rgba(17, 24, 39, 0.03)',
    },
    pageContainer: {
      colorBgPageContainer: '#ffffff',
    },
  },
};

export default Settings;
